<template>
<div id="expediente_manifestacion" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>

    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Expediente Manifestación" class="elevation-1 px-5 py-3" >
                <br>          

        <v-tabs grow style="margin-bottom: 30px;" >            
            <v-tabs-slider color="primary" ></v-tabs-slider>
            
            <v-tab :key="'in-view'" >Vista Previa de Contenido de Expediente</v-tab>                        
            <v-tab :key="'in-report'" >Generar ZIP de Descarga De Expediente</v-tab>            

            <v-tab-item :key="'in-view'" >
              <div class="contenedor-tab-dev" >
                <v-card-text>
                    <v-card-title>
                        <span class="headline" ></span>
                    </v-card-title>
                    <v-form ref="form" lazy-validation>
                        <v-container grid-list-md text-xs-center>
                            <v-row no-gutters dense>
                                <v-col cols="12" sm="3" lg="3" class="pa-0 ps-2 pt-1" >
                                    <!-- <v-autocomplete v-model="model.anio" :items="anios" :hide-no-data="true" 
                                        :return-object="false"  label="Seleccione un Año" :rules="[validaAnio]" @change="getAnios('anio')" >
                                    </v-autocomplete> -->
                                    <v-text-field v-model="model.anio" label="Ingresa un Año" :rules="[validaAnio]"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" lg="6" class="pa-0 ps-2 pt-1" >
                                    <v-autocomplete  v-model="model.emisor" :items="emisores" :item-text="getNombreEmisor" item-value="rfc"
                                        :hide-no-data="true"  label="Seleccione un Emisor" >
                                    </v-autocomplete>
                                </v-col>
                                
                                <v-col cols="12" sm="3" lg="3" class="pa-0 ps-2 pt-1" >
                                    <!-- <v-autocomplete v-model="model.aduana" :items="aduanas" :hide-no-data="true" 
                                        :return-object="false" label="Seleccione una Aduana" >
                                    </v-autocomplete> -->
                                    <v-text-field v-model="model.aduana" label="Ingresa una Aduana" maxlength="3"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row no-gutters dense>
                                <v-col cols="12" sm="3" lg="3" class="pa-0 ps-2 pt-1" >
                                    <!-- <v-autocomplete v-model="model.patente" :items="patentes" :hide-no-data="true" 
                                        :return-object="false" label="Seleccione una Patente" >
                                    </v-autocomplete> -->
                                    <v-text-field v-model="model.patente" label="Ingresa una Patente" maxlength="4"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="5" lg="5" class="pa-0 ps-2 pt-1" >
                                    <v-autocomplete v-model="model.tipo_documento" :items="tipos_documento" clearable
                                        :hide-no-data="true" item-text="valor" item-value="tipo" multiple
                                        :return-object="false" label="Seleccione un Tipo Documento" >
                                    </v-autocomplete>                                    
                                </v-col>
                                <v-col cols="12" sm="3" lg="3" class="pa-0 ps-2 pt-1" >
                                    <v-text-field label="No. Pedimento" hint="Ejemplo: 240-0123-0000123" v-model="model.pedimento" :rules="[validaAnio, validaPedimento]" ></v-text-field>                                                                        
                                </v-col>
                                <v-col cols="12" sm="1" lg="1" class="pa-0 ps-2 pt-1" >
                                    <v-btn icon title="Pegar Listado" @click="dialog1 = !dialog1" v-tippy>
                                        <v-icon colorHover="secondary" size="48" >mdi-clipboard-list-outline</v-icon>
                                    </v-btn>
                                </v-col>                                
                            </v-row>                               
                        </v-container>                        
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="formaCarpeta('preview')" >
                        <v-icon>done</v-icon>Generar Reporte de Contenido
                    </v-btn>                    
                </v-card-actions>
                <v-card-text>
                    <v-refresh-button :funcion="cargarReportesPreview" />                    
                    <v-client-table ref="vuetable" :data="datosPreview" :columns="columns" :options="options" class="elevation-2 pa-2" >
                        <template slot="noResults" >
                            <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                        </template>

                        <template slot="actions" slot-scope="props" >                            
                            <v-btn text icon color="success" title="Ver Expediente" v-if="props.row.estatus=='Generado Correctamente' " @click="cargarDetalle(props.row.id)" >
                                <v-icon dark>folder</v-icon>
                            </v-btn>
                            <v-btn text icon color="info" title="Generar ZIP" v-if="props.row.estatus=='Generado Correctamente' " @click="generarZIP(props.row.id)" >
                                <v-icon dark>archive</v-icon>
                            </v-btn>
                            <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                                <v-icon dark>delete</v-icon>
                            </v-btn>
                        </template>
                    </v-client-table>
                </v-card-text>
              </div>
            </v-tab-item>
            <v-tab-item :key="'in-report'" >
              <div class="contenedor-tab-dev" >
                <v-card-text>
                    <v-card-title>
                        <span class="headline" ></span>
                    </v-card-title>
                    <v-form ref="form2" lazy-validation>
                        <v-container grid-list-md text-xs-center>
                            <v-row no-gutters dense>
                                <v-col cols="12" sm="3" lg="3" class="pa-0 ps-2 pt-1" >
                                    <!-- <v-autocomplete v-model="model.anio" :items="anios" :hide-no-data="true" 
                                        :return-object="false"  label="Seleccione un Año" :rules="[validaAnio]" @change="getAnios('anio')"  >
                                    </v-autocomplete> -->
                                    <v-text-field v-model="model.anio" label="Ingresa un Año" :rules="[validaAnio]"></v-text-field>
                                    
                                </v-col>
                                <v-col cols="12" sm="6" lg="6" class="pa-0 ps-2 pt-1" >
                                    <v-autocomplete  v-model="model.emisor" :items="emisores" :item-text="getNombreEmisor" item-value="rfc"
                                        :hide-no-data="true"  label="Seleccione un Emisor" >
                                    </v-autocomplete>
                                </v-col>
                                
                                <v-col cols="12" sm="3" lg="3" class="pa-0 ps-2 pt-1" >
                                    <!-- <v-autocomplete v-model="model.aduana" :items="aduanas" :hide-no-data="true" 
                                        :return-object="false" label="Seleccione una Aduana" >
                                    </v-autocomplete> -->
                                    <v-text-field v-model="model.aduana" label="Ingresa una Aduana" maxlength="3"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row no-gutters dense>
                                <v-col cols="12" sm="3" lg="3" class="pa-0 ps-2 pt-1" >
                                    <!-- <v-autocomplete v-model="model.patente" :items="patentes" :hide-no-data="true" 
                                        :return-object="false" label="Seleccione una Patente" >
                                    </v-autocomplete> -->
                                    <v-text-field v-model="model.patente" label="Ingresa una Patente" maxlength="4"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="5" lg="5" class="pa-0 ps-2 pt-1" >
                                    <v-autocomplete v-model="model.tipo_documento" :items="tipos_documento" clearable
                                        :hide-no-data="true" item-text="valor" item-value="tipo" multiple
                                        :return-object="false" label="Seleccione un Tipo Documento" >
                                    </v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="3" lg="3" class="pa-0 ps-2 pt-1" >
                                    <v-text-field label="No. Pedimento" hint="Ejemplo: 240-0123-0000123" v-model="model.pedimento" :rules="[validaAnio, validaPedimento]" ></v-text-field>                                                                        
                                </v-col>
                                <v-col cols="12" sm="1" lg="1" class="pa-0 ps-2 pt-1" >
                                    <v-btn icon title="Pegar Listado" @click="dialog2 = !dialog2" v-tippy>
                                        <v-icon colorHover="secondary" size="48" >mdi-clipboard-list-outline</v-icon>
                                    </v-btn>
                                </v-col>                                
                            </v-row>                                 
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="formaCarpeta('completo')" >
                        <v-icon>done_all</v-icon>Generar ZIP de Descarga y Reporte de Contenido
                    </v-btn>
                </v-card-actions>

                <v-card-text>
                    <v-refresh-button :funcion="cargarReportes" />                    
                    <v-client-table ref="vuetable" :data="datos" :columns="columns" :options="options" class="elevation-2 pa-2" >
                        <template slot="noResults" >
                            <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                        </template>

                        <template slot="actions" slot-scope="props" >
                            <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="setDescarga(props.row.filename,props.row.id)" >
                                <v-icon dark>get_app</v-icon>
                            </v-btn>
                            <v-btn text icon color="success" title="Ver Expediente" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="cargarDetalle(props.row.id)" >
                                <v-icon dark>folder</v-icon>
                            </v-btn>
                            <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                                <v-icon dark>delete</v-icon>
                            </v-btn>
                        </template>
                    </v-client-table>
                </v-card-text>
              </div>
            </v-tab-item>
          </v-tabs>                                         

                    <!-- MODAL DETALLES -->
                    <v-dialog v-model="modal" max-width="80%" style=" z-index: 400 !important;" >
                        <v-card>
                            <v-card-title>
                                <v-card class="primary white--text titulomodal" >
                                    <v-icon class="white--text" >list</v-icon>&nbsp;
                                    <span class="subheading" >
                                        <strong>Expediente Manifestación</strong>
                                    </span>
                                </v-card>
                                <v-spacer></v-spacer>
                                <v-btn icon @click.native="modal = false" class="close_modal" >
                                    <v-icon class="white--text" >cancel</v-icon>
                                </v-btn>
                            </v-card-title>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <exportar-excel :data="data_resumen" :exportFields="data_resumen_excel" name="Resumen_Expediente.xlsx" >
                                    <v-btn dark small color="success" title="Exportar Resumen" v-tippy>
                                        <v-icon dark>get_app</v-icon> Resumen de Contenido
                                    </v-btn>
                                </exportar-excel>
                                &nbsp;&nbsp;&nbsp;
                                <v-btn dark small color="success" title="Exportar Detalle" v-tippy @click="downloadFile(key_detalle)" >
                                    <v-icon dark>get_app</v-icon> Detalle de Contenido
                                </v-btn>
                                &nbsp;&nbsp;&nbsp;
                                <exportar-excel v-if="data_descargas.length>0" :data="data_descargas" :exportFields="data_descargas_excel" name="Bitácora_Entrega.xlsx" >
                                    <v-btn dark small color="success" title="Exportar Bitácora Entrega" v-tippy>
                                        <v-icon dark>get_app</v-icon> Bitácora de Entrega
                                    </v-btn>
                                </exportar-excel>
                            </v-card-actions>
                            <v-card-text>       
                                <span><strong>Resumen de Manifestaciones contenidas en el expediente solicitado</strong></span>                                
                                <v-client-table ref="vuetabledetalle" :data="data_resumen" :columns="columns_resumen" :options="options_resumen" class="elevation-2 pa-2" >
                                    <template slot="noResults" >
                                        <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                    </template>
                                    
                                </v-client-table>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn @click.native="modal = false" >
                                    <v-icon>cancel</v-icon>Cerrar
                                </v-btn>                                
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                 </base-material-card>


            </v-flex>
        </v-layout>
    </v-container>

    <v-divider></v-divider>
    <v-dialog v-model="dialog1" max-width="500px" >
        <v-card>
            <v-card-text>
                <h5>Ingrese lista de pedimentos</h5>
                <span>Uno por línea</span>
                <v-form ref="formListado" lazy-validation="" >
                    <v-textarea outlined
                        rows="15"
                        v-model="listado"
                        :rules="[validaListado]"
                        ></v-textarea>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn  small @click="listado=''; dialog1 = false" >Cancelar</v-btn>
                <v-btn  small color="primary" @click="generaReporteListado('preview');" >Buscar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialog2" max-width="500px" >
        <v-card>
            <v-card-text>
                <h5>Ingrese lista de pedimentos</h5>
                <span>Uno por línea</span>
                <v-form ref="formListado" lazy-validation="" >
                    <v-textarea outlined
                        rows="15"
                        v-model="listado"
                        :rules="[validaListado]"
                        ></v-textarea>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn  small @click="listado=''; dialog2 = false" >Cancelar</v-btn>
                <v-btn  small color="primary" @click="generaReporteListado('completo');" >Buscar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import RefreshButton from "@/components/RefreshButton.vue";
export default {
    components: {
        "v-refresh-button": RefreshButton,
    },
    data: () => ({
        emisores: [],
        permisoEliminar: false,
        fab: false,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },            
            {
                text: "EManifiesto",
                disabled: true,
                to: ""
            },
            {
                text: "Expediente Manifestación",
                disabled: true,
                to: ""
            }
        ],
        datos: [],
        datosPreview: [],
        dialog1: false,        
        dialog2: false,        
        listado:"",
        
        columns: ["id","fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error", "actions"],
        options: {
            filterable: ["id","fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],
            sortable: ["id","fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],

            headings: {
                id:"No. Proceso",
                fecha_solicitud: "Solicitado",
                usuario_email: "Usuario",
                nombre_reporte: "Reporte",
                criterio: "Criterio de Búsqueda",
                fecha_generacion: "Generado",
                estatus: "Estatus",
                error: "Error",
                actions: "Opciones"
            }
        },
        show_loading: true,
        loadingAnios: true,        

        anios: [],                    
        aduanas: [],
        patentes: [],
        pedimentos: [],
       
        model: {
            rfc: "",
            usuario: "",
            anio: "",
            emisor: "",
            aduana: "",
            patente: "",
            pedimento: "",
            carpeta: "",
            reporte_url: "/reportes_ws/expediente_manifestacion_preview/",
            nombre_reporte: "Expediente Manifestacion",
            tipo: "Expediente Manifestacion",
            tipo_documento: [],
        },        
        
        rules: {
            required: v => !!v || "Este campo es requerido",
            numeric: value => {
                const pattern = /^[\d]*$/;
                return pattern.test(value) || "Solo se permiten números";
            }
        }, 

        modal:false,
        data_resumen:[],        
        data_resumen_excel: {          
            "Proceso MV":"nombre_proceso",
            "RFC Emisor":"rfc_emisor",
            "RFC Representante":"rfc_representante",
            "Estatus":"estatus",
            "Nombre Manifestación":"nombre_manifestacion",
            "Patente":"patente",
            "Sección Aduanera":"seccion_aduanera",
            "Número Pedimento":"numero_pedimento",
            "Fecha Pago Real":"fecha_pago_real",
            "Fecha Entrada":"fecha_entrada",
            "Año":"anio",
            "Mes":"mes",
            "T.C.":"tipo_cambio",
            "Clave Documento":"clave_documento",
            "Adicionales":"adicionales",
            "Tipo Pedimento":"tipo_pedimento"
        },
        columns_resumen: ["nombre_proceso","rfc_emisor","rfc_representante","estatus","nombre_manifestacion","patente","seccion_aduanera","numero_pedimento","fecha_pago_real",
            "fecha_entrada","anio","mes","tipo_cambio","clave_documento","adicionales","tipo_pedimento"],
        options_resumen: {
            filterable: ["nombre_proceso","rfc_emisor","rfc_representante","estatus","nombre_manifestacion","patente","seccion_aduanera","numero_pedimento","fecha_pago_real",
            "fecha_entrada","anio","mes","tipo_cambio","clave_documento","adicionales","tipo_pedimento"],
            sortable: ["nombre_proceso","rfc_emisor","rfc_representante","estatus","nombre_manifestacion","patente","seccion_aduanera","numero_pedimento","fecha_pago_real",
            "fecha_entrada","anio","mes","tipo_cambio","clave_documento","adicionales","tipo_pedimento"],
            headings: {                
                "nombre_proceso":"Proceso MV",
                "rfc_emisor":"RFC Emisor",
                "rfc_representante":"RFC Representante",
                "estatus":"Estatus",
                "nombre_manifestacion":"Nombre Manifestación",
                patente:"patente",
                seccion_aduanera:"Sección Aduanera",
                numero_pedimento:"Número Pedimento",
                fecha_pago_real:"Fecha Pago Real",
                fecha_entrada:"Fecha Entrada",
                anio:"Año",
                mes:"Mes",
                tipo_cambio:"T.C.",
                clave_documento:"Clave Documento",
                adicionales:"Adicionales",
                tipo_pedimento:"Tipo Pedimento",                
            }
        },

        key_detalle:"",
        data_descargas:[],
        data_descargas_excel: {
            "Fecha Descarga":"fecha",
            "Usuario":"usuario"            
        },
        tipos_documento: [            
            {"tipo":"edocument","valor":"PDF Edocument"},
            {"tipo":"edocument_acuse","valor":"PDF Acuse Edocument"},
            {"tipo":"cove","valor":"PDF COVE"},
            {"tipo":"cove_acuse","valor":"PDF Acuse COVE"},
            {"tipo":"pdf","valor":"PDF MV"},
            //{"tipo":"pdf_acuse","valor":"PDF Acuse MV"}, //Este PDF todavía no se hace
            {"tipo":"pdf_formatoe2","valor":"PDF Formato E2"},
            
            {"tipo":"xml_envio","valor":"XML Envio MV"},
            {"tipo":"xml_respuesta","valor":"XML Respuesta MV"},
            {"tipo":"xml_consulta","valor":"XML Consulta MV"},
            {"tipo":"xml_consulta_respuesta","valor":"XML Respuesta Consulta MV"},
            {"tipo":"xml_acuse","valor":"XML Acuse MV"},
            {"tipo":"xml_acuse_respuesta","valor":"XML Respuesta Acuse MV"},
            
            {"tipo":"adjuntos","valor":"Adjuntos"},
        ],
    }),

    methods: {        
        validaAnio: function(){
            var strPedimento = this.model.pedimento.trim();
            if (this.model.anio == 0 && strPedimento == "")
                return "Al menos ingrese el año o un número de pedimento";
            return true;
        },
        validaPedimento: function(){
            if (this.model.pedimento != ""){
                if (!this.validarPatronPedimento(this.model.pedimento))          
                    return "Pedimento no válido. Ejemplo: 240-0123-0000123";
            }
            return true;
        },
        validarPatronPedimento(pedimento){
            const patternPedimento = /^[0-9]{3}-{1}[0-9]{4}-{1}[0-9]{7}$/;
            return patternPedimento.test(pedimento);
        },
        validaListado: function(){            
            var listadoSinEspacios = this.removerLineasVacias(this.listado);
            if (listadoSinEspacios.length == 0) {
                return "Ingrese al menos 1 pedimento. Favor de verificar.";
            } else if (listadoSinEspacios.length > 50){
                return "No se puede consultar mas de 50 pedimentos";
            } else {
                for(var k in listadoSinEspacios){
                    if (!this.validarPatronPedimento(listadoSinEspacios[k]))
                        return "Verificar pedimentos no válidos. Ejemplo: 240-0123-0000123";
                }
            } 
            
            return true;
        },       
        removerLineasVacias(listado){
            var listadoSplit = this.listado.split("\n");
            var listadoSinEspacios = listadoSplit.filter(item => {
                return item.trim() != "";
            });
            return listadoSinEspacios;
        },
        getAnios: function (opcion) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');                        
            
            if (opcion == "anio"){
                this.aduanas = [];
                this.model.aduana= "";    
                this.patentes = [];
                this.model.patente= "";                        
            }             

            let data = {
                rfc: this.model.rfc,                
                carpeta: this.getCarpeta(),
            };

            axios.post(this.$hostname + "reportes_ws/get_anios_pedimentos/", data)                     
                .then(res => {
                    if (typeof res.data !== "undefined") {                        
                        if (this.model.anio != 0){
                            this.setCombo(res.data);                            
                        } else {
                            this.anios = res.data;
                        }                        
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los años de los pedimentos.",
                        footer: ""
                    });
                    console.log(err);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        setCombo: function(datos){
            this.emisores.push({"rfc":"Todos","razon_social":""});
            this.aduanas = datos.aduanas;
            this.aduanas.push("Todas");
            this.patentes = datos.patentes;
            this.patentes.push("Todas");

        },
        cargarReportes: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.model.rfc,
                "tipo": "Expediente Manifestacion"
            };
            axios.post(this.URL + "get_reportes/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datos = res.data;
                        this.datos.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud) ;
                        });
                        for (var k in this.datos) {
                            this.datos[k].fecha_solicitud = this.parseDate(this.datos[k].fecha_solicitud);
                            this.datos[k].fecha_generacion = this.parseDate(this.datos[k].fecha_generacion);
                            this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
                            this.datos[k].criterio = this.getCriterio(this.datos[k].criterio);
                        }
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los reportes de expediente.",
                        footer: ""
                    });
                    console.log(err);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        cargarReportesPreview: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.model.rfc,
                "tipo": "Manifestacion Contenido"
            };
            axios.post(this.URL + "get_reportes/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.datosPreview = res.data;
                        this.datosPreview.sort(function (a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud) ;
                        });
                        for (var k in this.datosPreview) {
                            this.datosPreview[k].fecha_solicitud = this.parseDate(this.datosPreview[k].fecha_solicitud);
                            this.datosPreview[k].fecha_generacion = this.parseDate(this.datosPreview[k].fecha_generacion);
                            this.datosPreview[k].estatus = this.getEstatus(this.datosPreview[k].estatus);
                            this.datosPreview[k].criterio = this.getCriterio(this.datosPreview[k].criterio);
                        }
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los reportes de contenido.",
                        footer: ""
                    });
                    console.log(err);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        
        getEstatus: function (estatus) {
            var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
            if (estatus in arr_estatus)
                return arr_estatus[estatus];
            else
                return "N/A";
        },
        getCriterio: function (criterio) {
            try {
                if (criterio != undefined && criterio.toString().trim() != "") {
                    var params = JSON.parse(criterio);
                    var criterio = "";
                    if (params.listado!= undefined && params.listado.length>0){
                        criterio += "Buscado por lista de pedimentos: "+params.listado.length;
                    } else if (params.pedimento!=undefined && params.pedimento != ""){
                        criterio += "Pedimento: " + params.pedimento;
                    } else {
                        if (params.anio!=undefined && params.anio!=0)
                        criterio += "Año: " + params.anio;
                        if (params.emisor!=undefined && params.emisor != "")
                            criterio += ", Emisor: " + params.emisor;
                        if (params.aduana!=undefined && params.aduana != "")
                            criterio += ", Aduana: " + params.aduana;
                        if (params.patente!=undefined && params.patente != "")
                            criterio += ", Patente: " + params.patente;
                    }


                    return criterio;
                } else {
                    return "N/A";
                }
            } catch (error) {
                console.log(error);
                return "N/A-error";
            }
        },
        cargarEmisores: function () {
            var datos = {
                cliente: this.$local_storage.get("id_cliente")
            };
            axios
                .post(this.$hostname + "catalogos/emisores_destinatarios/get_emisores/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.emisores = res.data;
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los emisores.",
                        footer: ""
                    });
                });
        },
        getNombreEmisor:function(record){
            return record.rfc+" - "+record.razon_social;
        },
        cargarDetalle: function (idReporte) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {                
                "id_reporte": idReporte,
                "tipo":"manifestacion",
            };                      
            axios.post(this.$hostname + "reportes_ws/get_bitacora_descarga/", data)            
                .then(res => {
                    if (typeof res.data != undefined) {
                        this.data_resumen = res.data.resumen;
                        this.key_detalle = res.data.detalle;
                        this.data_descargas = res.data.descargas;
                        console.log(res.data);
                        //console.log(res.data.resumen);
                        
                        for (var k in this.data_resumen) {
                            this.data_resumen[k].fecha_pago_real = this.parseDate(this.data_resumen[k].fecha_pago_real);
                            this.data_resumen[k].fecha_entrada = this.parseDate(this.data_resumen[k].fecha_entrada);                            
                        }
                        for (var k in this.data_descargas) {
                            this.data_descargas[k].fecha = this.parseDateTime(this.data_descargas[k].fecha);  
                        }
                        this.modal = true;
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los detalles del expediente.",
                        footer: ""
                    });
                    console.log(err);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    
                });
        },
        generarZIP: function(id_reporte){
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios({
                    method: "post",
                    url: this.$hostname + "reportes/genera_zip_reporte/",                    
                    data: {"id_reporte":id_reporte, "tipo":"manifestacion"}
                })
                .then(response => {
                    this.$swal({
                        type: "success",
                        title: "Operación Exitosa",
                        text: "El reporte se está generando. Cuando esté listo recibirá una notificación y podrá descargar el zip en la pestaña"+
                                " 'Generar ZIP de Descarga de Expediente'",
                        footer: ""
                    });
                })
                .catch(error => {
                    let mensaje;
                    if (typeof error.response !== "undefined") {
                        mensaje = error.response.data.mensaje;
                    } else {
                        mensaje = "Ocurrió un error al generar el reporte";
                    }

                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: ""
                    });
                }).then(() => {
                    this.cargarReportes();
                    this.cargarReportesPreview();
                    this.$root.$dialogLoader.hide();
                });    
        },

        setDescarga: function (key, idReporte) {            
            let data = {                
                "id_reporte": idReporte,
                "tipo":"manifestacion",
                "descarga":{"usuario":this.$local_storage.get("email"),
                            "fecha":  this.parseDateTime(moment()) }
            };
            
            axios.post(this.$hostname + "reportes_ws/set_bitacora_descarga/", data)
                .then(res => {
                    this.downloadFile(key);
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al guardar bitácora de descarga.",
                        footer: ""
                    });
                    console.log(err);
                });
        },

        getCarpeta: function(){
            var carpeta = "";
            if (this.model.anio != 0){
                //Ejemplo: AEM000515F97/pedimentos/2019/10/Exportaciones/730/3658/730-3658-9004587/
                carpeta = this.model.rfc.toUpperCase()+"/pedimentos/"+this.model.anio;                
            } 
            this.model.carpeta = carpeta;
            return carpeta;
        },

        generaReporteListado(tipoReporte){
            if (this.$refs.formListado.validate()) {
                this.generar_reporte_sqs(tipoReporte);
                this.dialog1 = false;
                this.dialog2 = false;
            }            
        },
        formaCarpeta(tipoReporte){

            if(tipoReporte=='completo' )
                    if (!this.$refs.form2.validate()) {
                        //Alguna operación o mensaje
                    } else {
                                                
                        
                        if (tipoReporte=='completo' && this.model.anio!=0){ //Si solo eligió año, mostramos mensaje
                            this.$swal({
                                type: "warning",
                                title: "Confirmar!!",
                                text: "El expediente solicitado generará un archivo Zip con todos los documentos de las manifestacion con pedimentos del año "+this.model.anio+
                                        " ¿Desea continuar?",
                                footer: "",
                                showCancelButton: true,
                                cancelButtonColor: "#d33",
                                confirmButtonColor: "#3085d6",
                                confirmButtonText: "Si",
                                cancelButtonText: "No"
                            }).then(result => {
                                if (result.value) {                                                    
                                    this.generar_reporte_sqs(tipoReporte);
                                } else {
                                    return false;                        
                                }
                            });
                        } else {
                            this.generar_reporte_sqs(tipoReporte);
                        }
                    }

          if(tipoReporte !='completo' )
                    if (!this.$refs.form.validate()) {
                        //Alguna operación o mensaje
                    } else {
                                                
                        
                        if (tipoReporte=='completo' && this.model.anio!=0){ //Si solo eligió año, mostramos mensaje
                            this.$swal({
                                type: "warning",
                                title: "Confirmar!!",
                                text: "El expediente solicitado generará un archivo Zip con todos los documentos de las manifestacion con pedimentos del año "+this.model.anio+
                                        " ¿Desea continuar?",
                                footer: "",
                                showCancelButton: true,
                                cancelButtonColor: "#d33",
                                confirmButtonColor: "#3085d6",
                                confirmButtonText: "Si",
                                cancelButtonText: "No"
                            }).then(result => {
                                if (result.value) {                                                    
                                    this.generar_reporte_sqs(tipoReporte);
                                } else {
                                    return false;                        
                                }
                            });
                        } else {
                            this.generar_reporte_sqs(tipoReporte);
                        }
                    }


        },
        
        generar_reporte_sqs(tipoReporte) {                            
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');   
            
            if (tipoReporte == "completo"){
                this.model.reporte_url = "/reportes_ws/expediente_manifestacion/";
                this.model.nombre_reporte= "Expediente Manifestacion";
                this.model.tipo = "Expediente Manifestacion";
            } else{
                this.model.reporte_url = "/reportes_ws/expediente_manifestacion_preview/";
                this.model.nombre_reporte= "Manifestacion Contenido";
                this.model.tipo = "Manifestacion Contenido";
            }
            var data = this.model;
            data["listado"] = this.removerLineasVacias(this.listado);            

            console.log(data);
            
            
            axios({
                    method: "post",
                    url: this.$hostname + "reportes_ws/valida_busqueda_expediente_manifestacion/",                         
                    data: data
                })
                .then(response => {
                    this.$swal({
                        type: "success",
                        title: "Operación Exitosa",
                        text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
                        footer: ""
                    });
                })
                .catch(error => {
                    let mensaje;
                    var titulo = "¡Operación no Permitida!";
                    var tipo = "error";
                    if (typeof error.response !== "undefined") {
                        mensaje = error.response.data.mensaje;
                        if (error.response.status == 406){
                            titulo = "¡Ya existe un reporte en proceso!";
                            tipo = "info";
                        }
                    } else {
                        mensaje = "Ocurrió un error al generar el reporte";                            
                    }
                    this.$swal({
                        type: tipo,
                        title: titulo,
                        text: mensaje,
                        footer: ""
                    });
                }).then(() => {
                    this.listado="";
                    this.cargarReportes();
                    this.cargarReportesPreview();
                    this.$root.$dialogLoader.hide();
                });            
        },
                
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        parseDateTime(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
        },
       
        downloadFile: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {                        
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        a.click();
                        a.parentNode.removeChild(a);                        
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {                    
                    this.$root.$dialogLoader.hide();
                });
        },
        eliminarReporte: function (idreporte) {
            this.$swal({
              type: "info",
              title: "Cuidado",
              text: "¿Está seguro de eliminar el reporte con No. Proceso: "+idreporte+"?",
              footer: "",
              showCancelButton: true,
              cancelButtonColor: "#d33",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar"
          }).then(result => {
            if (result.value) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var datos = {
                    id_reporte: idreporte,                
                }
                axios.post(this.$hostname + 'reportes/eliminar_reporte/', datos)
                    .then((res) => {
                    this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El reporte se eliminó correctamente",
                            footer: ""
                        });
                    })
                    .catch((error) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                            footer: '',
                        });
                        console.log(error);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.cargarReportes();
                        this.cargarReportesPreview();                                        
                    });
            }
          });
        },
    }, //methods
    created: function () {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.URL = this.$hostname + "reportes/";
        this.model.usuario = this.$local_storage.get("id_usuario");
        this.model.rfc = this.$local_storage.get("rfc");        
        var tipoUsuario = this.$local_storage.get("tipo_usuario");        
        if (tipoUsuario=="Soporte" || tipoUsuario=="Super Usuario")
            this.permisoEliminar = true;            
        this.getAnios();        
        this.cargarEmisores();
        this.cargarReportesPreview();
        this.cargarReportes();           
    }
};
</script>
<style>
#VueTables_th--actions {
        width: 115px;
    }        
</style>
<style scoped>
.theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active), .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-icon, .theme--light.v-tabs > .v-tabs-bar .v-tab--disabled {
    color:black;
    font-size: small;
    background-color: #EEEEEE;
    padding: 0px;
}
.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small ;
    background-color: #df7205;
    padding: 0px;
    font-weight: bold;
  
}
.v-tabs-slider-wrapper {
    left: 0 !important;
}
.table-bordered thead th, .table-bordered thead td {
    font-size: x-small !important;
}
</style>
